import { ArrayDataSource } from './BaseDataSources';
import { ITextValuePair } from '../Interfaces';

export class DealColumnFilterSource extends ArrayDataSource<ITextValuePair<string>> {
  public constructor(packageStatus: string | null = null, columnName: string | null = null) {
    super(`/datasource/filterlist/${packageStatus}/columnName/${columnName}`);
  }
}